module.exports = __webpack_public_path__ + "static/media/Subject-cover-placeholder.dde34fdb.png";